import { useEffect, useState } from 'react'
import { useAdminApi } from '../api'
import { t } from '../i18n'
import { useLang } from '../LangContext'
import { TemporadaDetail } from './TemporadaDetail'
import editStyles from '../adminEdit.module.css'
import { Icon } from '../../styles/Icon'

interface Temporada {
  id: string
  nombre: string
  fecha_inicio: string
  fecha_fin: string
  estado: 'abierta' | 'cerrada'
}

export function TemporadasPage() {
  const api = useAdminApi()
  const lang = useLang()
  const [temporadas, setTemporadas] = useState<Temporada[]>([])
  const [selected, setSelected] = useState<string | null>(null)
  const [form, setForm] = useState({ nombre: '', fecha_inicio: '', fecha_fin: '' })

  async function refresh() {
    setTemporadas(await api.get('/admin/temporadas'))
  }

  useEffect(() => {
    refresh()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  async function handleCreate(e: React.FormEvent) {
    e.preventDefault()
    await api.post('/admin/temporadas', form)
    setForm({ nombre: '', fecha_inicio: '', fecha_fin: '' })
    await refresh()
  }

  async function handleClose(id: string) {
    if (!window.confirm(t('cerrarTemporadaConfirm', lang))) return
    await api.post(`/admin/temporadas/${id}/close`)
    await refresh()
  }

  async function handleOpen(id: string) {
    if (!window.confirm(t('reabrirTemporadaConfirm', lang))) return
    await api.post(`/admin/temporadas/${id}/open`)
    await refresh()
  }

  async function handleDelete(id: string) {
    if (!window.confirm(t('borrarTemporadaConfirm', lang))) return
    try {
      await api.del(`/admin/temporadas/${id}`)
      await refresh()
    } catch (error) {
      window.alert(error instanceof Error ? error.message : t('error', lang))
    }
  }

  return (
    <div>
      <h2>{t('temporadas', lang)}</h2>
      {/* fix-mobile-responsive: etiquetas visibles (antes dos fechas sin indicar cuál es cuál). */}
      <form onSubmit={handleCreate} className={editStyles.createForm}>
        <label>
          {t('nombre', lang)}
          <input
            placeholder={t('nombre', lang)}
            required
            value={form.nombre}
            onChange={(e) => setForm({ ...form, nombre: e.target.value })}
          />
        </label>
        <label>
          {t('fechaInicio', lang)}
          <input
            type="date"
            required
            value={form.fecha_inicio}
            onChange={(e) => setForm({ ...form, fecha_inicio: e.target.value })}
          />
        </label>
        <label>
          {t('fechaFin', lang)}
          <input
            type="date"
            required
            value={form.fecha_fin}
            onChange={(e) => setForm({ ...form, fecha_fin: e.target.value })}
          />
        </label>
        <button type="submit"><Icon name="crear" />{t('crear', lang)}</button>
      </form>

      <div className="table-scroll">
      <table>
        <thead>
          <tr>
            <th>{t('nombre', lang)}</th>
            <th>{t('estado', lang)}</th>
            <th />
          </tr>
        </thead>
        <tbody>
          {temporadas.map((temporada) => (
            <tr
              key={temporada.id}
              aria-current={selected === temporada.id ? 'true' : undefined}
              className={selected === temporada.id ? editStyles.rowEditing : undefined}
            >
              <td>{temporada.nombre}</td>
              <td>
                <span>{temporada.estado === 'abierta' ? t('abierta', lang) : t('cerrada', lang)}</span>
              </td>
              <td>
                <button onClick={() => setSelected(temporada.id)}><Icon name="editar" />{t('editar', lang)}</button>
                {temporada.estado === 'abierta' ? (
                  <button onClick={() => handleClose(temporada.id)}><Icon name="cerrar" />{t('cerrarTemporada', lang)}</button>
                ) : (
                  <button onClick={() => handleOpen(temporada.id)}><Icon name="abrir" />{t('reabrirTemporada', lang)}</button>
                )}
                <button onClick={() => handleDelete(temporada.id)}><Icon name="eliminar" />{t('eliminar', lang)}</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      </div>

      {selected && (
        <TemporadaDetail
          temporadaId={selected}
          nombre={temporadas.find((temporada) => temporada.id === selected)?.nombre ?? ''}
          onClose={() => setSelected(null)}
        />
      )}
    </div>
  )
}
